/**
 * Focus the search input belonging to the dropdown that just opened.
 *
 * Call from a Tippy `@onShown` handler, which receives the tippy instance.
 *
 * `id="searchable"` is not unique — `Dropdowns::Searchable` and
 * `Wizard::Search` both hardcode it — so a document-wide lookup can land on an
 * input elsewhere on the page. On the initiatives table the page-level
 * `Wizard::Search` renders above the table, so focusing it scrolled the whole
 * page back to the top every time a cell dropdown opened.
 *
 * Scoping to the instance's own popper picks the right input even with several
 * dropdowns mounted, and `preventScroll` keeps focus from moving the viewport
 * at all.
 *
 * @param {object} [instance] tippy instance passed to `onShown`
 */
export default function focusDropdownSearch(instance) {
  instance?.popper
    ?.querySelector('#searchable')
    ?.focus?.({ preventScroll: true });
}
